export enum PREDICTIONS_SUB_PAGES_IDS {
  PREDICTIONS_INVOICES = 'predictions-invoices',
  PREDICTIONS_SALES = 'predictions-sales',
  PREDICTIONS_COSTS = 'predictions-costs',
  PREDICTIONS_EXPENSES = 'predictions-expenses',
  PREDICTIONS_OTHER_P_AND_L = 'predictions-other-p-and-l',
  PREDICTIONS_ASSETS = 'predictions-assets',
  PREDICTIONS_LIABILITIES = 'predictions-liabilities',
  PREDICTION_PROFIT_LOSS = 'predictions-profit-and-loss',
  PREDICTION_BALANCE_SHEET = 'predictions-balance-sheet',
  PREDICTION_CASH_FLOW = 'predictions-cash-flow-statement'
}
